import type { RemirrorJSON } from '@remirror/core';

export function getPlainTextFromDoc(doc: RemirrorJSON): string {
  const parts: string[] = [];

  function walk(node: RemirrorJSON): void {
    if (node.type === 'text' && node.text != null) {
      parts.push(node.text);
    } else if (node.type === 'mentionAtom' && node.attrs) {
      parts.push(String(node.attrs['label'] ?? ''));
    } else if (node.type === 'hardBreak') {
      parts.push('\n');
    } else {
      const children = node.content ?? [];
      for (const child of children) {
        walk(child);
      }
    }
  }

  walk(doc);
  return parts.join('');
}
